export function getFromLocalStorage(itemName:string) {
  const item = localStorage.getItem(itemName);
  const numPatt = new RegExp(/^\d+$/);
  const jsonPatt = new RegExp(/[[{].*[}\]]/);

  if (item) {
    if (jsonPatt.test(item)) {
      return JSON.parse(item);
    } else if (numPatt.test(item)) {
      return parseFloat(item);
    } else {
      return item;
    }
  } else {
    return null;
  }
}


export function setInLocalStorage(itemName, item) {
  if (typeof item === 'object'){
    localStorage.setItem(itemName, JSON.stringify(item));
  } else {
    localStorage.setItem(itemName, item);
  }
}

export function removeFromLocalStorage(itemName) {
  localStorage.removeItem(itemName);
}

